export default "__VITE_ASSET__2813fddd__"